import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage, setMessageStatus } from "./messages";

import AuthService from "../services/auth.service";

const user = localStorage.getItem("userToken");

export const register = createAsyncThunk(
    "auth/register",
    async (inputs, thunkAPI) => {
        try {
            const response = await AuthService.register({ inputs });
            thunkAPI.dispatch(setMessage(response.data.message));
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const login = createAsyncThunk(
    "auth/login",
    async (inputs, thunkAPI) => {
        try {
            const data = await AuthService.login({ inputs });
            return { user: data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const updateProfile = createAsyncThunk(
    "profile/update",
    async (inputs, thunkAPI) => {
        try {
            const data = await AuthService.profileUpdate({ inputs });
            return { user: data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const getprofile = createAsyncThunk(
    "my-profile",
    async (thunkAPI) => {
        try {
            const data = await AuthService.getprofile();

            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const logout = createAsyncThunk("auth/logout", async () => {
    await AuthService.logout();
});

const initialState = user ? { isLoggedIn: true, user, Status: 'Idel' } : { isLoggedIn: false, user: null, Status: 'Idel' };

const authSlice = createSlice({
    name: "auth",
    initialState,
    extraReducers: {
        [register.fulfilled]: (state, action) => {
            state.isLoggedIn = false;
            state.Status = "Success";
        },
        [register.rejected]: (state, action) => {
            state.isLoggedIn = false;
            state.Status = "Failed";
        },
        [login.fulfilled]: (state, action) => {
            state.isLoggedIn = true;
            state.user = action.payload.user;
            state.Status = "Success";
        },
        [login.rejected]: (state, action) => {
            state.isLoggedIn = false;
            state.user = null;
            state.Status = "Failed";
        },

        [getprofile.fulfilled]: (state, action) => {
            state.isLoggedIn = true;
            state.user = action.payload.user;
            state.Status = "Success";
        },
        [getprofile.rejected]: (state, action) => {
            state.isLoggedIn = false;
            state.user = null;
            state.Status = "Failed";
        },

        [updateProfile.fulfilled]: (state, action) => {
            state.Status = "Success";
            state.isLoggedIn = true;
            state.user = action.payload.user;
        },
        [updateProfile.rejected]: (state, action) => {
            state.Status = "Failed";
        },

        [logout.fulfilled]: (state, action) => {
            state.isLoggedIn = false;
            state.user = null;
        },
    },
});

const { reducer } = authSlice;
export default reducer;
